import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const TIMEZONE = 'Europe/Stockholm';

dayjs.tz.setDefault(TIMEZONE);

export default dayjs;
